{
  "aiGeneratedAnswer": "Trả lời do AI tạo",
  "allCategories": "Tất cả danh mục",
  "appliedFiltersToCurrentSearch": "Bộ lọc được áp dụng cho tìm kiếm hiện tại",
  "apply": "Áp dụng",
  "applyFilters": "Áp dụng bộ lọc",
  "autocompleteOptionsFound_other": "Đã tìm thấy {{count}} tùy chọn tự động hoàn thành{{label}}.",
  "autocompleteSuggestion": "đề xuất tự động hoàn thành: {{suggestion}}",
  "autocompleteSuggestionsFound_other": "Đã tìm thấy {{count}} đề xuất tự động hoàn thành.",
  "basedOnYourDevice": " (dựa trên thiết bị của bạn)",
  "basedOnYourInternetAddress": " (dựa trên địa chỉ internet của bạn)",
  "categoriesText_other": "Các danh mục sau có kết quả cho – <strong>{{query}}</strong>",
  "clearAll": "Xóa tất cả",
  "clearMinAndMax": "Xóa giá trị tối thiểu và tối đa",
  "clearTheRangeToSelectOptions": "Xóa phạm vi để chọn các tùy chọn.",
  "clearTheSearchBar": "Xóa thanh tìm kiếm",
  "conductASearch": "Tiến hành tìm kiếm",
  "currentLocation": "Vị trí hiện tại",
  "didYouMean": "Ý bạn là <button>{{correctedQuery}}</button> phải không",
  "dropDownScreenReaderInstructions": "Khi có kết quả tự động hoàn thành, dùng phím mũi lên/xuống để duyệt và Enter để chọn.",
  "feedback": "Phản hồi",
  "filterGroupSearchInputLabel": "Tìm kiếm trong các tùy chọn {{title}}",
  "invalidRange": "Phạm vi không hợp lệ",
  "max": "Tối đa",
  "min": "Tối thiểu",
  "navigateToTheNextResultsPage": "Điều hướng đến trang kết quả tiếp theo",
  "navigateToThePreviousResultsPage": "Điều hướng đến trang kết quả trước đó",
  "noAutocompleteOptionsFound": "0 tùy chọn tự động hoàn thành được tìm thấy.",
  "noAutocompleteSuggestionsFound": "0 đề xuất tự động hoàn thành được tìm thấy.",
  "noResultsFoundIn": "Không tìm thấy kết quả trong {{currentVerticalLabel}}.",
  "paginationPage": "trang {{pageNumber}}",
  "pagination": "Phân trang",
  "readMoreAbout": "Tìm hiểu thêm về <a>{{name}}</a>",
  "recentSearch": "Tìm kiếm gần đây: {{query}}",
  "recentSearchesFound_other": "Đã tìm thấy {{count}} lượt tìm kiếm gần đây.",
  "removeFilter": "Xóa bộ lọc “{{displayName}}”",
  "resultPreview": "Xem trước kết quả: {{value}}",
  "resultPreviewsFound_other": "Đã tìm thấy {{count}} bản xem trước kết quả.",
  "resultsCountText_other": "{{count}} kết quả",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} trên tổng {{resultsCount}} kết quả",
  "searchHere": "Tìm kiếm ở đây…",
  "showingAllInstead": "Hiển thị tất cả {{currentVerticalLabel}} thay vào đó.",
  "showLess": "Ẩn bớt",
  "showMore": "Xem thêm",
  "sources_other": "Nguồn ({{count}})",
  "submitSearch": "Gửi tìm kiếm",
  "suggestionResultsCount_other": "{{label}} – {{count}} kết quả",
  "thankYouForYourFeedback": "Cảm ơn bạn đã phản hồi!",
  "thisAnsweredMyQuestion": "Điều này đã trả lời câu hỏi của tôi",
  "thisDidNotAnswerMyQuestion": "Điều này không trả lời câu hỏi của tôi",
  "unselectAnOptionToEnterInARange": "Bỏ chọn một tùy chọn để nhập khoảng giá trị.",
  "updateYourLocation": "Cập nhật vị trí của bạn",
  "useCurrentLocation": "Dùng vị trí hiện tại",
  "useMyLocation": "Dùng vị trí của tôi",
  "viewAll": "Xem tất cả",
  "viewDetails": "Xem chi tiết"
}
